import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'center',
  templateUrl: './center.component.html',
  styleUrls: ['./center.component.scss']
})
export class CenterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
